import { useT } from '../../i18n';
import { selectExam, useAppStore } from '../../store/useAppStore';
import { Dialog } from '../../ui/Dialog';
import styles from './Start.module.css';

/**
 * Die Frage nach dem Wiedereinstieg.
 *
 * Erscheint nur, wenn beim Hochkommen eine angefangene Bewertung für einen Prüfling vorlag,
 * den es in der geladenen Prüfung noch gibt (s. `store/startup.ts`). Der Prüfer entscheidet —
 * die App entscheidet es nicht für ihn, weil beide Fälle vorkommen: das Gerät ist mitten in
 * der Station abgestürzt (weitermachen), oder es wurde seither an einen anderen Platz
 * gegeben (neu beginnen).
 */
export function ResumeDialog() {
  const t = useT();
  const exam = useAppStore(selectExam);
  const startup = useAppStore((s) => s.startup);
  const resumeYes = useAppStore((s) => s.resumeYes);
  const resumeNo = useAppStore((s) => s.resumeNo);

  if (startup.kind !== 'wiedereinstieg') return null;
  const { candidateId, stationId } = startup.stand;
  const candidate = exam.candidates.find((c) => c.id === candidateId);
  const station = exam.stations.find((st) => st.id === stationId);

  return (
    <Dialog
      kicker={t.start.resumeKicker}
      title={t.start.resumeTitle}
      onClose={resumeNo}
      width={480}
      dismissible={false}
    >
      <p className={styles.resumeBody}>
        {t.start.resumeBody(candidate?.name ?? '—', station?.label ?? '—')}
      </p>
      {/* Der Hinweis steht hier, weil „neu beginnen" sonst nach „verwerfen" klingt. Es
          verwirft nichts: `ExamLog` ist anhängend, die Bewertung bleibt und erscheint wieder,
          sobald derselbe Prüfling erneut gewählt wird. */}
      <p className={styles.resumeNote}>{t.start.resumeNote}</p>
      <div className={styles.resumeButtons}>
        <button type="button" className={`tap ${styles.secondary}`} onClick={resumeNo}>
          {t.start.resumeFresh}
        </button>
        <button type="button" className={`tap ${styles.primary}`} onClick={resumeYes}>
          {t.start.resumeKeep}
        </button>
      </div>
    </Dialog>
  );
}
